import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M15.8 15.8H2.2V2.2H9V1H1v16h16V9h-1.2v6.8zm-5.34-7.412l5.34-5.34v4.808l1.2-1.2V1h-5.657l-1.199 1.199h4.809L9.612 7.54l.848.848z" />
  </svg>
);

export default SvgComponent;
